import { useContext } from 'react';
import { AuthContext } from '@repo-level/core-front/contexts/auth';

import { ScrollBlock } from 'components/ScrollBlock';
import { AuthButtons } from 'components/auth/AuthButtons';
import { MenuDesktop } from '../Menu/MenuDesktop';
import { UserPanel } from '../Header/UserPanel';
import { AddonsContext } from 'contexts/addons';
import { Logo } from 'components/Logo';
import { PromoPanelsDesktop } from '../Header/PromoPanels';
import { BonanzaContext } from 'contexts/bonanza';
import { LanguageSwitcher } from 'components/LanguageSwitcher';

import { ScSidebar, ScSidebarContent } from './styles';

export const Sidebar = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { isBonanzaPromoAvailable } = useContext(BonanzaContext);

  const { isEmailConfirmationPopup, emailConfirmationPopupHeight } = useContext(
    AddonsContext
  );

  return (
    <ScSidebar
      withEmailConfirmationPopup={isEmailConfirmationPopup}
      emailConfirmationPopupHeight={emailConfirmationPopupHeight}
    >
      <ScrollBlock
        style={{
          height: '100vh',
          width: '176px',
          transition: 'all 0.5s ease',
        }}
      >
        <ScSidebarContent smallGap={isBonanzaPromoAvailable}>
          <Logo />
          {isAuthenticated ? <UserPanel /> : <AuthButtons />}
          <PromoPanelsDesktop />
          <div className="divider" />
          <MenuDesktop />
          <LanguageSwitcher />
        </ScSidebarContent>
      </ScrollBlock>
    </ScSidebar>
  );
};
